<div class="user-detail d-flex w-100 text-center align-items-center flex-column">
  <h4 class="w-100 text-truncate">{{ currentUser()?.name() }}</h4>
  <small class="w-100 text-truncate">{{ currentUser()?.email() }}</small>
</div>